import request from '@/utils/request'

export function userFeedback(data) {
    return request({
        url: 'api/personalUser/FeedBack',
        method: 'post',
        data
    })
}